import React, { useEffect } from "react";
import CommonUtil from "../common/CommonUtil";
import CommonActions from "../actions/CommonActions";

const CasinoCallback = () => {
    useEffect(() => {
        //will post message into parent frame when lost session
        CommonUtil.postMessage('lostSessionGameCasinoFrame');
    }, []);

    return (
        <React.Fragment>
            {CommonActions.renderWaitLoading(CommonUtil.getCurrentSkin())}
        </React.Fragment>
    );
}
export default CasinoCallback;


// WEBPACK FOOTER //
// ./src/app/pages/CasinoCallback.js